import { z } from 'zod';
import { uuidSchema } from './common.js';
/**
 * Contracts (BP-05/D-043) — the Contract Repository archive + the Expiry Calendar's dates. Each row
 * references the supplier (counterparty) + category masters by ID (D-100). Lean first cut: title,
 * type, status, effective/expiry dates, notice period, value, and a document pointer. AI templates,
 * the clause library, e-sign envelopes and obligations come in later slices. Shapes shared by the API
 * (validation) and the web app (types).
 */
export const contractStatusSchema = z.enum(['draft', 'active', 'signed', 'expired', 'terminated']);
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected a date as YYYY-MM-DD');
export const contractSchema = z.object({
    id: uuidSchema,
    supplierId: uuidSchema.nullable(),
    categoryId: uuidSchema.nullable(),
    title: z.string(),
    contractType: z.string().nullable(),
    status: contractStatusSchema,
    startDate: z.string().nullable(),
    endDate: z.string().nullable(),
    noticePeriodDays: z.number().nullable(),
    value: z.number().nullable(),
    currency: z.string(),
    documentRef: z.string().nullable(),
    isDemo: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
/** POST /contracts — add a contract record (source 'manual'). */
export const createContractSchema = z
    .object({
    title: z.string().trim().min(1).max(240),
    supplierId: uuidSchema.optional(),
    categoryId: uuidSchema.optional(),
    contractType: z.string().trim().max(60).optional(),
    status: contractStatusSchema.optional(),
    startDate: isoDate.optional(),
    endDate: isoDate.optional(),
    noticePeriodDays: z.number().int().min(0).max(3650).optional(),
    value: z.number().finite().optional(),
    currency: z.string().trim().length(3).optional(),
    documentRef: z.string().trim().max(500).optional(),
})
    .strict();
/** PATCH /contracts/:id — edit any field. */
export const patchContractSchema = z
    .object({
    title: z.string().trim().min(1).max(240).optional(),
    supplierId: uuidSchema.nullable().optional(),
    categoryId: uuidSchema.nullable().optional(),
    contractType: z.string().trim().max(60).nullable().optional(),
    status: contractStatusSchema.optional(),
    startDate: isoDate.nullable().optional(),
    endDate: isoDate.nullable().optional(),
    noticePeriodDays: z.number().int().min(0).max(3650).nullable().optional(),
    value: z.number().finite().nullable().optional(),
    currency: z.string().trim().length(3).optional(),
    documentRef: z.string().trim().max(500).nullable().optional(),
})
    .strict();
//# sourceMappingURL=contracts.js.map